export const TOTAL_PRICE_HEAD_GROUP = [
    {
        idx: 0,
        title: "객실",
    },
    {
        idx: 1,
        title: "시즌",
    },
    {
        idx: 2,
        title: "주중",
    },
    {
        idx: 3,
        title: "금요일",
    },
    {
        idx: 4,
        title: "주말/공휴일 전날",
    },
];
